import { LocalStorage } from '../../../_config/adapters/local-storage/local-storage.constant';

export const getLocation = () => {
	const location = localStorage.getItem(LocalStorage?.location);
	return JSON.parse(location);
};
